var map = {
	"./bunge.jpg": "b8ea",
	"./daniela.jpg": "a43a",
	"./gyalapak.jpg": "0be2",
	"./megaline.jpg": "d56b",
	"./olsidz.jpg": "9b0c",
	"./orexim.jpg": "c432",
	"./ukrbyd.jpg": "9894"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0128";